import { loadAppDetailPage } from '../views/app-square/navigation.js'

export const RESOURCE_MANAGEMENT_PATH = '/ai-resource/management'
export const APP_SQUARE_PATH = '/app-square'
export const EXPERIENCE_SQUARE_PATH = '/experience-square'

// 所有登录用户均可访问的资源管理入口，与角色菜单分开注册。
export const fixedAuthenticatedRoutes = [{
  path: APP_SQUARE_PATH,
  name: 'AppSquareLayout',
  component: () => import('@/layout/index.vue'),
  meta: { title: '自建应用', requiresAuth: true, hidden: true },
  children: [{
    path: '',
    name: 'AppSquare',
    component: () => import('@/views/app-square/index.vue'),
    meta: { title: '自建应用', requiresAuth: true, hidden: true }
  }, {
    path: ':id(\\d+)',
    name: 'AppSquareDetail',
    component: loadAppDetailPage,
    meta: { title: '应用详情', requiresAuth: true, hidden: true }
  }]
}, {
  path: EXPERIENCE_SQUARE_PATH,
  name: 'ExperienceSquareLayout',
  component: () => import('@/layout/index.vue'),
  meta: { title: '经验集市', requiresAuth: true, hidden: true },
  children: [{
    path: '',
    name: 'ExperienceSquare',
    component: () => import('@/views/experience-square/index.vue'),
    meta: { title: '经验集市', requiresAuth: true, hidden: true }
  }]
}, {
  path: RESOURCE_MANAGEMENT_PATH,
  name: 'ResourceManagementLayout',
  component: () => import('@/layout/index.vue'),
  meta: { title: '资源管理', requiresAuth: true, hidden: true },
  children: [{
    path: '',
    name: 'AiResourceManagement',
    component: () => import('@/views/ai-resource/management/index.vue'),
    meta: { title: '资源管理', requiresAuth: true, hidden: true }
  }]
}]

// 兼容角色仍绑定此菜单的账号，避免动态路由覆盖固定入口。
const fixedPaths = [RESOURCE_MANAGEMENT_PATH, APP_SQUARE_PATH, EXPERIENCE_SQUARE_PATH]
export function excludeFixedRoutes(routes, parentPath = '') {
  return routes.flatMap(route => {
    const path = (route.path.startsWith('/') ? route.path : `${parentPath}/${route.path}`)
      .replace(/\/+/g, '/').replace(/\/$/, '') || '/'
    if (fixedPaths.some(fixed => path === fixed || path.startsWith(`${fixed}/`))) return []
    if (!route.children?.length) return [route]
    const children = excludeFixedRoutes(route.children, path)
    return children.length ? [{ ...route, children }] : []
  })
}
